<template>
  <div ref="statisticsContainer" class="[&_a]:inline-block" />
</template>

<script setup lang="ts">
const route = useRoute()
const statisticsContainer = ref<HTMLElement>()

let previousUrl = ''

const generateStatistics = () => {
  if (!statisticsContainer.value) return

  // Clear previous content
  statisticsContainer.value.innerHTML = ''

  // Direct JavaScript execution without inline script
  const referrer = previousUrl || document.referrer || ''
  let java1 =
    'refer=' + encodeURIComponent(referrer) + '&page=' + encodeURIComponent(window.location.href)

  document.cookie = 'astratop=1; path=/'
  java1 += '&c=' + (document.cookie ? 'yes' : 'now')

  try {
    if (typeof navigator.javaEnabled === 'function') {
      java1 += '&java=' + (navigator.javaEnabled() ? 'yes' : 'now')
    }
  } catch {
    // javaEnabled throws in some browsers via Proxy restriction (Chrome 90+)
  }

  if (screen.width && screen.height) {
    java1 +=
      '&razresh=' +
      screen.width +
      'x' +
      screen.height +
      '&cvet=' +
      (navigator.appName.substring(0, 3) == 'Mic' ? screen.colorDepth : screen.pixelDepth)
  }

  java1 += '&jscript=1.3&rand=' + Math.random()

  const link = document.createElement('a')
  link.href = 'https://www.net.kg/stat.php?id=6690&fromsite=6690'
  link.target = '_blank'

  const img = document.createElement('img')
  img.src = 'https://www.net.kg/img.php?id=6690&' + java1
  img.border = '0'
  img.alt = 'WWW.NET.KG'
  img.width = '88'
  img.height = '31'

  link.appendChild(img)
  statisticsContainer.value.appendChild(link)

  // Update previous URL for next navigation
  previousUrl = window.location.href
}

// Generate statistics on mount and route change
onMounted(generateStatistics)

watch(() => route.fullPath, generateStatistics)
</script>
